import Vue from 'vue'
export default new Vue()


//////////////////
// WEBPACK FOOTER
// ./static/js/eventBus.js
// module id = Dlte
// module chunks = 20